import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { reduxForm, clearSubmitErrors } from 'redux-form';

import validate from './Form/validations';
import { copyFor, capitalization } from '../../copy/copy';

import HomeAddressInput from './Form/HomeAddressInput';
import PostalCodeInput from './Form/PostalCodeInput';
import Button from '../Button';
import TwoGroup from '../TwoGroup';

import { LoadingSpinner } from '../../components/LoadingSpinner';

const ButtonGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin-top: 0.75em;

    > div {
        position: relative;
    }

    button {
        &.submitButton {
            ${props => (props.submitting ? `text-indent: -99999px;` : '')};
        }

        &:focus {
            outline: none;
        }

        + div {
            position: absolute;
            display: none;
            top: 7px;
            right: 25%;
            margin-right: -16px;
            width: 32px !important;
            height: 32px !important;

            ${props => (props.submitting ? `display: block` : '')};
        }
    }
`;

const FindRepFormContainer = styled.form`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

const FormGroup = styled.div`
    margin-bottom: 0.75em;
`;

const FindRepForm = props => (
    <FindRepFormContainer onSubmit={props.handleSubmit} autocomplete="on">
        <FormGroup>
            <HomeAddressInput autoFocus={false} />
        </FormGroup>
        <FormGroup>
            <PostalCodeInput />
        </FormGroup>
        <ButtonGroup submitting={props.submitting}>
            <TwoGroup>
                <Button
                    label={copyFor('buttons', 'back', undefined, capitalization.eachWord)}
                    onClick={props.onBack}
                />
                <Button
                    primary={true}
                    label={copyFor(
                        'buttons',
                        'submit',
                        undefined,
                        capitalization.eachWord
                    )}
                    type="submit"
                    className="submitButton"
                    disabled={props.invalid}
                />
                <LoadingSpinner />
            </TwoGroup>
        </ButtonGroup>
    </FindRepFormContainer>
);

FindRepForm.propTypes = {
    onBack: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired
};

export default reduxForm({
    form: 'findRepForm',
    initialValues: {
        getUpdates: true
    },
    onChange: (values, dispatch, props) => {
        dispatch(clearSubmitErrors('findRepForm'));
    },
    validate
})(FindRepForm);



// WEBPACK FOOTER //
// ./src/components/LocalRep/FindRepForm.jsx